<template>
    <div class="back_homepage_arrow">
        <nuxt-link :to="backButtonMobile.to">
            {{ backButtonMobile.text }}
        </nuxt-link>
    </div>
</template>

<script>
export default {
    props: {
        items: {
            type: Array,
            required: true
        }
    },

    computed: {
        backButtonMobile() {
            const itemsLength = this.items.length;

            if (itemsLength < 2) {
                return {
                    text: this.$t('general.homepageLink'),
                    to: this.localePath('/')
                };
            }

            return this.items[itemsLength - 2];
        }
    }
};
</script>
